export default "__VITE_ASSET__BgUf_MYF__"